export default {"src":"/_next/static/media/groceries.3dd22a11.svg","height":137,"width":170,"blurWidth":0,"blurHeight":0};